export const FORMAT_TIME = 'HH:mm';
export const NINE_AM = '09:00';
export const ELEVEN_FIFTY_NINE_PM = '23:59';

export enum RangeDate {
  FROM = 'from',
  TO = 'to',
}
